import { z } from 'zod'

export const UsernameSchema = z
	.string({ required_error: 'Se requiere un nombre de usuario' })
	.min(3, { message: 'El nombre de usuario es demasiado corto' })
	.max(20, { message: 'El nombre de usuario puede tener como máximo 20 caracteres' })
	.regex(/^[a-zA-Z0-9_]+$/, {
		message: 'El nombre de usuario solo puede incluir letras, números y guiones bajos',
	})
	// users can type the username in any case, but we store it in lowercase
	.transform(value => value.toLowerCase())

export const PasswordSchema = z
	.string({ required_error: 'Se requiere contraseña' })
	.min(6, { message: 'La contraseña es demasiado corta' })
	.max(100, { message: 'La contraseña es demasiado larga' })
export const NameSchema = z
	.string({ required_error: 'Se requiere un nombre' })
	.min(3, { message: 'El nombre es demasiado corto' })
	.max(40, { message: 'El nombre es demasiado largo' })
export const EmailSchema = z
	.string({ required_error: 'Se requiere un correo electrónico' })
	.email({ message: 'El correo electrónico es inválido' })
	.min(3, { message: 'El correo electrónico es demasiado corto' })
	.max(100, { message: 'El correo electrónico es demasiado largo' })
	// users can type the email in any case, but we store it in lowercase
	.transform(value => value.toLowerCase())

export const UsernameOrEmailSchema = z
	.string({ required_error: 'Se requiere un nombre de usuario o correo electrónico' })
	.min(3, { message: 'El nombre de usuario o correo electrónico es demasiado corto' })
	.max(100, { message: 'El nombre de usuario o correo electrónico es demasiado largo' })
	// users can type the username/email in any case, but we store both in lowercase
	.transform(value => value.toLowerCase())
	.superRefine((value, ctx) => {
		const result = value.includes('@') ? EmailSchema.safeParse(value) : UsernameSchema.safeParse(value)

		if (result.success) return

		ctx.addIssue({
			code: z.ZodIssueCode.custom,
			message:
				result.error.issues[0]?.message ??
				(value.includes('@') ? 'El correo electrónico es inválido' : 'El nombre de usuario es inválido'),
		})
	})

export const PasswordAndConfirmPasswordSchema = z
	.object({ password: PasswordSchema, confirmPassword: PasswordSchema })
	.superRefine(({ confirmPassword, password }, ctx) => {
		if (confirmPassword !== password) {
			ctx.addIssue({
				path: ['confirmPassword'],
				code: 'custom',
				message: 'Las contraseñas deben coincidir',
			})
		}
	})
